import { Component, Input } from '@angular/core';

@Component({
  selector: 'fc-custom-badge',
  templateUrl: './fc-custom-badge.component.html',
  styleUrls: ['./fc-custom-badge.component.scss'],
})
export class FcCustomBadgeComponent {

  @Input() public text: string;
  @Input() public textColor: string;
  @Input() public bgColor: string;
}

